export const CONNECTION_STATUS = {
  GO_HOME_BUTTON: 'connection-status-go-home-button',
  RETURN_TO_PREVIOUS_PAGE_BUTTON: 'connection-status-return-to-previous-page-button',
  REFRESH_PAGE_BUTTON: 'connection-status-refresh-page-button',
  PROJECT_GO_HOME_BUTTON: 'connection-status-project-go-home-button',
  PROJECT_REFRESH_PAGE_BUTTON: 'connection-status-project-refresh-page-button'
} as const;
